import React from "react";
import { TabStripTab } from "@progress/kendo-react-layout";
import "./tab.scss";

// interface to declare all our prop types
interface Props {
  defaultChecked? :boolean;
  disabled?: boolean;
  title?: any;
  children: React.ReactNode;
}

const Tab: React.FC<Props> = ({
  disabled,
  title,
  children,
}) => {

    
  return (
    <>
    <TabStripTab title={title}  disabled={disabled} >
        {children} 
    </TabStripTab>
    </>
  );
};

export default Tab;
